import type { SVGProps } from 'react';

const SvgDoubleChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.0827 20L21.0827 16L17.0827 12" stroke="currentColor" strokeWidth={1.5} />
    <path d="M11.0827 20L15.0827 16L11.0827 12" stroke="currentColor" strokeWidth={1.5} />
  </svg>
);

export default SvgDoubleChevronRight;
